import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Checkbox, Button, DrawerDivider } from 'components/patterns'
import featuresStrings from 'utils/strings/features-strings'
import AssignFastFeatureDetailsModal from './AssignFastFeatureDetailsModal'
import {
  FastFeatureControlWrapper,
  FastFeatureRow,
  CheckboxLabel,
} from './FastFeatureControl.style'

const FastFeatureControl = ({
  featureId,
  featureNumber,
  revision,
  featureDescription,
  minDiagVariant,
  ecu,
  isFastFeature,
  isToggling,
  onLoad,
  onToggle,
}) => {
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    if (featureId) onLoad({ featureId })
  }, [featureId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleCheckboxChange = (e) => {
    onToggle({ featureId, isFastFeature: e.target.checked })
  }

  const handleOpenModal = () => setModalOpen(true)
  const handleCloseModal = () => setModalOpen(false)

  return (
    <>
      <FastFeatureControlWrapper>
        <FastFeatureRow>
          <Checkbox
            checked={isFastFeature}
            disabled={isToggling}
            onChange={handleCheckboxChange}
          >
            <CheckboxLabel>
              {featuresStrings.fast_feature_status_label}
            </CheckboxLabel>
          </Checkbox>
          <Button
            type="secondary"
            size="small"
            disabled={!isFastFeature || isToggling}
            onClick={handleOpenModal}
          >
            {featuresStrings.edit_fast_feature_details}
          </Button>
        </FastFeatureRow>
      </FastFeatureControlWrapper>
      <DrawerDivider />

      {modalOpen && (
        <AssignFastFeatureDetailsModal
          featureId={featureId}
          featureNumber={featureNumber}
          revision={revision}
          featureDescription={featureDescription}
          minDiagVariant={minDiagVariant}
          ecu={ecu}
          onClose={handleCloseModal}
        />
      )}
    </>
  )
}

FastFeatureControl.propTypes = {
  featureId: PropTypes.string.isRequired,
  featureNumber: PropTypes.string,
  revision: PropTypes.string,
  featureDescription: PropTypes.string,
  minDiagVariant: PropTypes.string,
  ecu: PropTypes.string,
  isFastFeature: PropTypes.bool,
  isToggling: PropTypes.bool,
  onLoad: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
}

FastFeatureControl.defaultProps = {
  featureNumber: '-',
  revision: '-',
  featureDescription: '',
  minDiagVariant: '',
  ecu: '',
  isFastFeature: false,
  isToggling: false,
}

export default FastFeatureControl
